import React, {useEffect, useState} from 'react'
import { DataTable, Table, Button } from '@arnsbogroup/react-voicearchive'
import { useHistory } from 'react-router-dom'

const Span = ({ children }) => <span>{ children }</span>
const PdfLink = ({ invoiceId, orderId, draft }) => <a href={`/invoice/pdf?invoiceId=${invoiceId}&orderId=${orderId}&draft=${+draft}`} target="_blank">PDF Version</a>

const Invoices = ( {customer, onChange} ) => {
    if (!customer) {
        return null
    }

    const [state, setState] = useState({
      loading: false
    });
    const [invoices, setInvoices] = useState([]);
    const [balance, setBalance] = useState(null);
    const history = useHistory()

    useEffect(() => {
      fetchInvoices();
      fetchBalances();
    }, [customer]);

    const fetchInvoices = () => {
      setState({ ...state, loading: true });
      fetch(`/rest/v1/customer/${customer.uid}/invoices`)
      .then((response) => response.json())
      .then((data) => {
        setState({ ...state, loading: false });
        if (Array.isArray(data)) {
          setInvoices(data);
        }
      });
    }

    const fetchBalances = () => {
      fetch(`/rest/v2/customer/balances?customerId[]=${customer.uid}`)
      .then((response) => response.json())
      .then((data) => {
        setBalance(data[customer.uid]);
      });
    }

    function syncInvoices() {
      const body = new FormData()
      body.append('customerId', customer.uid)
      fetch(`/customer/createOrUpdateDebtor.json`, { method: 'POST', body })
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          toastr.success('Company debtor created successfully');
        } else {
          toastr.error(response.errors);
        }
      });
    }

    return (
      <div className='p-4'>
        <div className="grid grid-cols-2 gap-2">
          <h2>Balance: {balance}</h2>
          <div className='text-right'>
            <Button size="xs" className="mb-4" onClick={syncInvoices}>Sync</Button>
          </div>
        </div>
        {invoices.length > 0 ? (
          <DataTable
            className="w-full"
            components={{
            Tr: ({ childProps = {}, ...innerProps }) => {
                return (
                <Table.Tr className="cursor-pointer" onClick={() => childProps.orderId ? history.push(`/orders/${childProps.orderId}/overview`) : undefined}
                    {...innerProps }
                />
                )
            },
            Td: Table.Td
            }}
            head={{
              type: { label: 'Type' },
              invoiceId: { label: 'Invoice #' },
              netAmount: { label: 'Net Amount' },
              dueDate: { label: 'Due Date' },
              remainder: { label: 'Remainder' },
              pdfHref: { label: 'Pdf' },
              orderId: { label: 'Order' },
            }}
            body={{
              type: Span,
              invoiceId: Span,
              netAmount: Span,
              dueDate: Span,
              remainder: Span,
              pdfHref: PdfLink,
              orderId: Span,
            }}
            entries={invoices}
          />
        ) : (
          <div className="text-center text-gray-500">
            {state.loading ? 'Loading...' : 'No invoices'}
          </div>
        )}

      </div>
    )
}

export default Invoices
